var $03c9a1a10de12f06$exports = {};
$03c9a1a10de12f06$exports = {
  "Clear search": "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
};
export { $03c9a1a10de12f06$exports as default };